import { useContext } from "react";
import { MdArrowOutward, MdCheckCircle } from "react-icons/md";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";

function getServiceImage(image = "") {
  if (!image) {
    return "";
  }

  if (String(image).startsWith("http://") || String(image).startsWith("https://")) {
    return image;
  }

  return `${CDN_URL}${image}`;
}

export default function OneService({ uuid, image, title, description, items = [], categoryTitle }) {
  const appContext = useContext(AppContext);

  return (
    <div className="card tff-service-card tff-service-card-lg ">
      <div
        className="tff-service-cover"
        style={{
          backgroundImage: `url(${getServiceImage(image)})`,
        }}
      >
        <div className="tff-service-cover-overlay">
          <span className="tff-service-chip">{categoryTitle || "Tourism Service"}</span>
          <h4 className="font-bold text-light mt-3 mb-2">{title}</h4>
          <p className="font-light text-light mNoMargin">{description}</p>
        </div>
      </div>

      <div className="card-body d-flex flex-column p-4">
        {items.map((item) => (
          <div key={item} className="tff-inline-list-item">
            <MdCheckCircle size={18} className="text-secondary me-2 flex-shrink-0" />
            <span>{item}</span>
          </div>
        ))}

        <button
          className="btn btn-outline-primary btn-rounded btn-padded mt-auto align-self-start"
          onClick={() => {
            appContext.navTo({
              item: "services",
              subItem: "service",
              extraItem: uuid,
            });
          }}
        >
          Inquire About This
          <MdArrowOutward size={18} className="ms-2" />
        </button>
      </div>
    </div>
  );
}
